export default "__VITE_ASSET__YQZ3kmnV__"